class Stack {
  constructor() {
    this._stack = []
  }

  add(el) {
    if (!el) return
    this._stack.push(el)
  }

  addMulti(el) {
    if (!el || !Array.isArray(el)) return
    this._stack = this._stack.concat(el)
  }

  isEmpty() {
    return this._stack.length === 0
  }

  getStackLength() {
    return this._stack.length
  }

  *[Symbol.iterator]() {
    while (!this.isEmpty()) {
      const [...copy] = this._stack
      const el = copy[0]
      this._stack.shift()
      yield el
    }
  }
}

class InteralList {
  constructor() {
    this._listener = new Map()
  }

  add(funcName, func, time, immediate) {
    if (this._listener.get(funcName)) return
    if (immediate) func.apply(this)
    const _tmp = setInterval(func, time)
    this._listener.set(funcName, _tmp)
  }

  /**
   * @author Elicxh
   * @param {*} arr 输入为空则清楚全部,有则清空数组内部的定时器
   */
  drop(arr) {
    if (Array.isArray(arr)) {
      arr.map((funcName) => {
        const _timeId = this._listener.get(funcName)
        clearTimeout(_timeId)
        // this._listener.delete(funcName)
      })
    }
    if (arr === null || arr === undefined) {
      this._listener.forEach((value, key) => {
        clearTimeout(value)
      })
    }
  }
}

function genId() {
  let count = 0
  return () => {
    return count++
  }
}

const generateId = genId()

// 广度优先遍历
function searchDFSDOM(node, arr) {
  let collection = arr
  //
  if (node.children.length === 0) {
    collection.push(node.className)
    return collection
  }

  collection.push(node.className)

  for (let i = 0; i < node.children.length; i++) {
    const cNode = node.children[i]
    const cArr = searchDFSDOM(cNode, collection)
    collection = collection.concat(cArr)
  }

  return collection
}

export { Stack, InteralList, generateId, searchDFSDOM }
